import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyDetailsThunk, logout } from "../store/thunks/authThunks";
import { setPrimaryBranch, setSelectedBranch } from "store/slices/branchSlice";
import branchService from "../services/branchService";

const useAuth = () => {
  const dispatch = useDispatch();
  const { token, user, loading } = useSelector((state) => state.auth);
  const { selectedBranch } = useSelector((state) => state.branch);
  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState(null);

  const setPrimaryBranchState = async () => {
    if (user?.branchAccess?.primaryBranch && !selectedBranch) {
      dispatch(setSelectedBranch(user.branchAccess.primaryBranch));

      try {
        const primaryBranch = await branchService.getBranchByCode(
          user.branchAccess.primaryBranch
        );
        console.log("response", { primaryBranch });
        dispatch(setPrimaryBranch(primaryBranch));
      } catch (error) {
        console.log("Error while setting primeryBranch", error);
      }
    }
  };

  useEffect(() => {
    const initializeAuth = async () => {
      if (token && !user && !loading && !initialized) {
        try {
          await dispatch(getMyDetailsThunk());
        } catch (err) {
          setError(err.message || "An error occurred");
          dispatch(logout());
        } finally {
          setInitialized(true);
        }
      } else if (!token) {
        setInitialized(true);
      }
    };

    setPrimaryBranchState();
    initializeAuth();
  }, [token, user, loading, initialized, dispatch]);

  return {
    isAuthenticated: !!token && !!user && !loading && !error,
    loading,
    error,
  };
};

export default useAuth;
